import { render } from "./CampaignPerformance.vue?vue&type=template&id=55468c8d&scoped=true"
import script from "./CampaignPerformance.vue?vue&type=script&lang=js"
export * from "./CampaignPerformance.vue?vue&type=script&lang=js"

import "./CampaignPerformance.vue?vue&type=style&index=0&id=55468c8d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55468c8d"]])

export default __exports__